<script>
	import HrefIcon from './HrefIcon.svelte';
	import { fly } from 'svelte/transition';

	const icon_list = [
		{icon: 'fab fa-twitter', href: 'https://twitter.com/PoolAion', text: 'PoolAion'},
		{icon: 'fab fa-telegram', href: 'https://t.me/cardano_aion_pool', text: 't.me/cardano_aion_pool'},
		{icon: 'fas fa-at', href: 'mailto: aionpool@protonmail.com', text: 'aionpool@protonmail.com'}
	];

</script>
<style>
	footer {
		text-align: center;
		background-color: RGBA(3,3,3,0.4);
		color: white;
		bottom: 0;
		width: 100%;
	}
	a, a:active, a:hover, a:visited {
		color: #65b6e3;
		text-decoration: none;
	}
	div {
		margin: auto;
		width: 50%;
		display: table;
	}
	div a {
		font-size: 5em;
	}
	div .icon {
		width: 400px;
		display:table-cell;
	}
	.bottom {
		font-size: 20px;
		color: #65b6e3;
	}
</style>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css">

<footer>
	<div>
		{#each icon_list as icon}
			<div class="icon">
				<HrefIcon let:hovering={hovering}>
					<a href={icon.href} class="{icon.icon}">
				</a>
					{#if hovering}
						<div 
						in:fly="{{delay: 0, duration: 200, x: 0, y: -10, opacity: 0.0}}"
						out:fly="{{delay: 0, duration: 200, x: 0, y: 10, opacity: 0.0}}"
						class="bottom">
							{icon.text}
						</div>
					{/if}
				</HrefIcon>
			</div>
		{/each}
	</div>
</footer>
